
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Wallet_Modal: 'walletModal',
    Modal_handle: 'modalHandle',
}
